import MetaTags from "@/components/seo/meta-tags";
import ComplianceSupport from "@/components/us-website/ComplianceSupport/ComplianceSupport";
import FeatureImageWithBlur from "@/components/us-website/FeatureImageWithBlur/FeatureImageWithBlur";
import RegulatoryCompliance from "@/components/us-website/RegulatoryCompliance/RegulatoryCompliance";
import SiteCertifications from "@/components/us-website/SiteCertifications/SiteCertifications";
import SedexData from "@/components/us-website/SedexData/SedexData";
import Sustainability from "@/components/us-website/Sustainability/Sustainability";
import { getCDNImageUrl } from "@/utils/Common";
import React from "react";

function Compliance() {
  return (
    <div>
      <MetaTags
        title="Driving Sustainability in the Chemical Industry | Elchemy"
        description="Elchemy ensures sustainable sourcing and full regulatory compliance for chemical ingredients supplied across the US personal care industry."
      />
      {/* Feature Image With Blur */}
      <FeatureImageWithBlur
        heading="Our Commitment to Compliance and Sustainability"
        description="Explore how Elchemy ensures every product meets global regulatory standards while advancing a sustainable chemical supply chain for the future."
        imageSrc={getCDNImageUrl("compliance-hero.webp")}
      />
      {/* Regulatory Compliance */}
      <RegulatoryCompliance />
      {/* Compliance Support */}
      <ComplianceSupport />
      {/* Sustainability */}
      <Sustainability />
      {/* Site Certifications */}
      <SiteCertifications />
      {/* Sedex Data */}
      <SedexData />
    </div>
  );
}

export default Compliance;
